import React, { useState, useEffect } from 'react'
import { useMenu, useCurrentRefinements  } from 'react-instantsearch-core'
import { QuestionMark } from '../../icons'

export type Item = {
  image: string
  label: string
  help: string
}

export type Props = {
  attribute: string
  title: string
  items: Item[]
  showIcon: boolean
  isOpen: boolean
  onToggle: () => void
}

export const Select: React.FC<Props> = ({ attribute, title, items, showIcon, isOpen, onToggle }) => {
  const { refine } = useMenu({ attribute })
  const currentRefinements = useCurrentRefinements({ includedAttributes: [attribute] })
  const [selectedItem, setSelectedItem] = useState<string>('All')

  const handleSelectItem = (label: string) => {
    onToggle()

    if (label === 'All') {
      if (selectedItem !== 'All') {
        setSelectedItem('All')
        refine('')
      }
    } else {
      setSelectedItem(selectedItem === label ? 'All' : label)
      refine(selectedItem === label ? '' : label)
    }
  }

  useEffect(() => {
    function handleClickOutside(event) {
      const isOutsideDropdown = !event.target.closest(".customDropdown") && !event.target.closest(".customDropdown-DropdownContainer")
      if (isOutsideDropdown && isOpen) {
        onToggle()
      }
    }

    document.addEventListener("click", handleClickOutside)
    return () => {
      document.removeEventListener("click", handleClickOutside)
    }
  }, [isOpen, onToggle])

  useEffect(() => {
    if (currentRefinements.items.length === 0) {
      setSelectedItem('All')
    }
  }, [currentRefinements])

  const isAllSelected = selectedItem === 'All'

  return (
    <div className="customDropdown">
      <label className="Algolia-selectLabel">
        {title} {showIcon && <QuestionMark />}
      </label>
      <div className={`customDropdown-inner ${isOpen ? 'open' : ''}`} onClick={onToggle}>
        {isAllSelected ? 'All' : selectedItem}
      </div>
      {isOpen && (
        <ul className="customDropdown-DropdownContainer">
          <li
            className={`customDropdown-DropdownItem ${isAllSelected ? 'selected' : ''}`}
            onClick={() => handleSelectItem('All')}
          >
            <span className={`customDropdown-checkboxIcon ${isAllSelected ? 'selected' : ''}`}></span>
            All
          </li>
          {items.map((item, index) => (
            <li
              key={index}
              className={`customDropdown-DropdownItem ${selectedItem === item.label ? 'selected' : ''}`}
              onClick={() => handleSelectItem(item.label)}
            >
              <span className={`customDropdown-checkboxIcon ${selectedItem === item.label ? 'selected' : ''}`}></span>
              {item.image && <img src={item.image} className="customDropdown-imageIcon" alt={item.label} />} {item.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}